import { useCallback, useMemo, useRef, useState } from 'react';
import type { TableExternalControl } from 'ksnm-common-ui/lib/Table2/Table.interface';
import type { MutableRefObject} from 'react';

import { ksnmTableStore } from '@stores/ksnmTableStore/ksnmTableStore';

interface IUseUpdateTable {
  clearCheckbox?: boolean;
  tableName: string;
}

export const useUpdateTable = ({
  clearCheckbox = true,
  tableName,
}: IUseUpdateTable): [number, () => void, MutableRefObject<TableExternalControl | null>] => {
  const { clearSelectedFromLocalStorage } = ksnmTableStore;

  const externalControl = useRef<TableExternalControl | null>(null);

  const [tableKey, setTableKey] = useState(-1);

  const update = useCallback(() => {
    setTableKey(Date.now());

    if (clearCheckbox) {
      externalControl.current?.clearCheckboxes?.();
      clearSelectedFromLocalStorage(tableName as string);
    }
  }, [clearCheckbox, clearSelectedFromLocalStorage, tableName]);

  return useMemo(() => [tableKey, update, externalControl], [tableKey, update]);
};
